
import React, { useEffect, useLayoutEffect, useState } from "react";
import  "./EditUser.css";
import { useGlobalContext } from "../../context";
import { Dropdown } from  "primereact/dropdown";
import { findConfiguration, editUser } from "../../api";
import Holidays from "date-holidays";
import { useNavigate } from "react-router-dom";

function EditUser() {

    const {
        setNavbarData,
        categorys,
        setCategorys,
        profileType,
        weekDays,
        setWeekDays,
        concretUser
    } = useGlobalContext()

    const [configData, setConfigData] = useState({});
    const [typeProfile, setTypeProfile] = useState("");
    const [typeCategory, setTypeCategory] = useState("");
    const [additionalCategory, setAdditionalCategory] = useState("");
    const [facebookId, setFacebookId] = useState("");
    const [hashtag, setHashtag] = useState("");
    const [caption, setCaption] = useState("");
    const [checkCustomer, setCheckCustomer] = useState(false);
    const [holidaysPosts, setHolidaysPosts] = useState(true);
    const [showHolidays, setShowHolidays] = useState(false);
    const [holidays, setHolidays] = useState([]);
    const [activeDays, setActiveDays] = useState([]);

    // const findConfig = async (id) => {
    //     const data = await findConfiguration(id);
    //     if (data) setConfigData(data.data);
    // }

    useLayoutEffect(() => {
        setWeekDays(
            [
                {
                    text: "Mon",
                    name: "Monday",
                    active: false,
                    postToInstagram: false,
                    postToFacebook: false,
                    time: ""
                },
                {
                    text: "Tue",
                    name: "Tuesday",
                    active: false,
                    postToInstagram: false,
                    postToFacebook: false,
                    time: ""
                },
                {
                    text: "Wed",
                    name: "Wednesday",
                    active: false,
                    postToInstagram: false,
                    postToFacebook: false,
                    time: ""
                },
                {
                    text: "Thu",
                    name: "Thursday",
                    active: false,
                    postToInstagram: false,
                    postToFacebook: false,
                    time: ""
                },
                {
                    text: "Fri",
                    name: "Friday",
                    active: false,
                    postToInstagram: false,
                    postToFacebook: false,
                    time: ""
                },
                {
                    text: "Sat",
                    name: "Saturday",
                    active: false,
                    postToInstagram: false,
                    postToFacebook: false,
                    time: ""
                },
                {
                    text: "Sun",
                    name: "Sunday",
                    active: false,
                    postToInstagram: false,
                    postToFacebook: false,
                    time: ""
                },
            ]
        )
    },[])

    const findCountryHols = (config) => {
        if (config.holidayCountry !== "CANADA") {
            const holidaysUSAUpdate = new Holidays("US").getHolidays(new Date().getFullYear()).map((item, index) =>{ return { ...item, active: false, id: index + 1 } });
            setHolidays(holidaysUSAUpdate);
        }
        else {
           const hdCanadaUpdate = new Holidays("CA").getHolidays(new Date().getFullYear()).map((item, index) =>{ return { ...item, active: false, id: index + 1 } });
            setHolidays(hdCanadaUpdate);
        }
    }

    useEffect(() => {
        if (concretUser) {
            setTypeProfile(profileType.find(item => item.text.toLowerCase() === concretUser.subscription.replaceAll("_", " and ").toLowerCase()));
            setFacebookId(concretUser.facebookProfileId);
            setHashtag(concretUser.hashtags);
            setCaption(concretUser.additionalTexts);
            setTypeCategory(categorys.find(item => item.text.toLowerCase() === concretUser.category.replaceAll("_", " ").toLowerCase()));
            setAdditionalCategory(categorys.find(item => item.text.toLowerCase() === concretUser.additionalCategory?.replaceAll("_", " ").toLowerCase()))
            // findConfig(concretUser.id);
        }
    }, [concretUser])

    const customClient = (config) => {
        const anotherPostMedia = config.dayOfWeekConfigurationList.find(item => !item.postToFacebook || !item.postToInstagram || item.postValidStartTime !== null);
        if (anotherPostMedia || config.dayOfWeekConfigurationList.length !== 3 || config.holidayPosts) {
            setCheckCustomer(true);
        }
        else {
            setCheckCustomer(false);
        }
    }

    useEffect(() => {
        const daysActive = weekDays.filter(day => day.active);
        setActiveDays(daysActive);
    }, [weekDays]);

    const userActiveHolidays = (configData) => {
        for (let i = 0; i < configData.holidays.length; i++) {
            setHolidays(hols => hols.map(item => {
                if (item.date.includes(configData.holidays[i])) {
                    return {
                        ...item,
                        active: true
                    }
                }
                else {
                    return { ...item };
                }
            }))
        }
    }

    const userActiveDays = (configData) => {
        for (let i = 0; i < configData.dayOfWeekConfigurationList.length; i++) {
            setWeekDays(weekDays => weekDays.map(item => {
                if (item.name.toLowerCase() === configData.dayOfWeekConfigurationList[i].day.toLowerCase()) {
                    return {
                        ...item,
                        id: configData.dayOfWeekConfigurationList[i].id,
                        postToFacebook: configData.dayOfWeekConfigurationList[i].postToFacebook,
                        postToInstagram: configData.dayOfWeekConfigurationList[i].postToInstagram,
                        time: configData.dayOfWeekConfigurationList[i].postValidStartTime,
                        active: true
                    }
                }
                else {
                    return { ...item }
                }
            }))
        }
    }

    useEffect(() => {
        if (configData.id) {
            customClient(configData);
            userActiveDays(configData);
            findCountryHols(configData);
            userActiveHolidays(configData);
            setHolidaysPosts(configData.holidayPosts);
            setShowHolidays(configData.holidayPosts);
        }
    }, [configData])

    useEffect(() => {
        if (configData.id) {
            if (holidaysPosts) {
                userActiveHolidays(configData);
                setShowHolidays(true);
            }
            else {
                setHolidays(holidays => holidays.map(hol => {
                    return { ...hol, active: holidaysPosts }
                }));
                setShowHolidays(false);
            }
        }
    }, [holidaysPosts])

    const checkActiveDays = (item, index) => {
        if ( activeDays.length < 3 ) {
            const secondOrNextDay = weekDays.find((day, number) => ( day.active && number === index + 1 ) || ( day.active && number === index - 1 ))
            if ( secondOrNextDay ) return false;
            else return true;
        }
        else if ( activeDays.length === 3 && item.active ) return true;
        else return false;
    }

    const activeThisDay = (item, index) => {
        if (checkActiveDays(item, index)) {
            setWeekDays(weekDays => weekDays.map(day => day.text === item.text ? { ...day, active: !day.active } : { ...day }));
        }
    }

    const changeTime = (value, day) => {
        if (day.active) {
            setWeekDays(weekDays => weekDays.map(item => item.text === day.text ? { ...item, time: value.$d.toLocaleTimeString("en-US") } : { ...item }));
        }
    }

    const changeFacebook = (day) => {
        if (day.active) {
            setWeekDays(weekDays.map(item => item.text === day.text ? { ...item, postToFacebook: !item.postToFacebook } : { ...item }));
        }
    }

    const changeInstagram = (day) => {
        if (day.active) {
            setWeekDays(weekDays.map(item => item.text === day.text ? { ...item, postToInstagram: !item.postToInstagram } : { ...item }));
        }
    }

    const checkedThisHoliday = (holiday) => {
        if (holidaysPosts) {
            setHolidays(holidays => holidays.map(item => item.id === holiday.id ? { ...item, active: !item.active } : { ...item }));
        }
        else {
            return;
        }
    }

    const navigate = useNavigate();

    const goToAllPage = () => {
        setTypeProfile("");
        setTypeCategory("");
        setFacebookId("");
        setNavbarData(navbarData => navbarData.map(item => item.id === 1 ? { ...item, active:true } : { ...item, active:false }));
        navigate("/");
    }
    console.log(additionalCategory)
    const createNewClient = async (e) => {
        e.preventDefault();
        let formData = new FormData();
        formData.append("id", concretUser.id);
        formData.append("facebookProfileId", facebookId);
        formData.append("category", typeCategory.text.replaceAll(" ", "_").toUpperCase());
        additionalCategory ? formData.append("additionalCategory", additionalCategory.text.replaceAll(" ", "_").toUpperCase()) : formData.append("additionalCategory", concretUser.additionalCategory );
        // formData.append("additionalCategory",  null)
        formData.append("subscription", typeProfile.text.replaceAll(" and ", "_").toUpperCase());
        formData.append("hashtags", hashtag);
        formData.append("additionalTexts", caption);
        for (var pair of formData.entries()) {
            console.log(pair[0]+ ', ' + pair[1]);
        }
        const submitData = await editUser(formData);
        console.log(submitData)
        if ( submitData ) {
            goToAllPage();

            // const weekData = weekDays.filter(item => item.active).map(item => {
            //     return {
            //         id: item.id,
            //         day: item.name.toUpperCase(),
            //         postToFacebook: item.postToFacebook,
            //         postToInstagram: item.postToInstagram,
            //         postValidStartTime: item.time
            //     }
            // })
            // const activeHolidays = holidays.filter(item => item.active).map(item => item.date.slice(0, item.date.indexOf(" ")));
            // let configs = {
            //     id: configData.id,
            //     clientId: submitData.data.id,
            //     holidayPosts: holidaysPosts,
            //     holidays: activeHolidays,
            //     dayOfWeeks: weekData
            // }
            // const submitConfigData = await createConfiguration(JSON.stringify(configs));
            // if ( submitConfigData ) {
            //     goToAllPage();
            // }
        }
    }

    return (
        <div className="addUserFormBox">
            <form
                className = "addUserForm"
                onSubmit = { createNewClient }
            >
                <div className="addUserFormInputsBox">
                    <h4 className="addUserHeadText">{"EDIT A USER" + " " + "(" + concretUser?.fullName + ")"}  </h4>
                    <label>Profile Type</label>
                    <Dropdown
                        options={ profileType }
                        optionLabel="text"
                        className="addUserDropdown"
                        value={ typeProfile }
                        onChange={ e => setTypeProfile(e.value) }
                        required={ true }
                    />
                    <label>Facebook ID</label>
                    <input
                        type="number"
                        className="addUserInput"
                        value={ facebookId }
                        onChange={ e => setFacebookId(e.target.value) }
                        required={ true }
                    />
                    <label>Category</label>
                    <Dropdown
                        options={categorys.filter(item => item.id !== 0)}
                        optionLabel="text"
                        className="addUserDropdown"
                        value={typeCategory}
                        onChange={e => setTypeCategory(e.value)}
                        required={true}
                    />
                    <label>Additional Category</label>
                    <Dropdown
                        options={categorys.filter(item => item.text !== typeCategory?.text)}
                        optionLabel="text"
                        className="addUserDropdown"
                        value={additionalCategory}
                        onChange={e => setAdditionalCategory(e.value)}
                        // required={ true }
                    />
                    <label> Custom Hashtag (Optional) </label>
                    <input
                        type="text"
                        className="addUserInput"
                        value={hashtag}
                        onChange={e => setHashtag(e.target.value)}
                    />
                    <label>Custom Caption (Optional)</label>
                    <textarea
                        className="addUserInput addUserTextArea"
                        value={caption}
                        onChange={e => setCaption(e.target.value)}
                    >
                    </textarea>
                </div>
                {/*<div className="addUserFormCheckinBox">*/}
                {/*    <span className="addUserCustomClientCheckSpan">*/}
                {/*        <label className="checkboxLabel">*/}
                {/*            <input*/}
                {/*                type = 'checkbox'*/}
                {/*                checked = { checkCustomer }*/}
                {/*                onChange = { e => setCheckCustomer(e.target.checked) }*/}
                {/*            />*/}
                {/*            <span></span>*/}
                {/*        </label>*/}
                {/*        Custom Client*/}
                {/*    </span>*/}
                {/*    <div className="addUserCustomDataBox" style={{ visibility: checkCustomer ? 'visible' : 'hidden' }}>*/}
                {/*        <label>*/}
                {/*            Posting Days*/}
                {/*        </label>*/}
                {/*        <div className="editUserWeekDaysBox">*/}
                {/*            {*/}
                {/*                weekDays.map((day, index) =>*/}
                {/*                    <div className="editUserConcretWeekDayBox">*/}
                {/*                        <span*/}
                {/*                            key = { day.text }*/}
                {/*                            className = "editUserWeekDay"*/}
                {/*                            onClick = { activeThisDay.bind(this, day, index) }*/}
                {/*                            style = {{*/}
                {/*                                backgroundColor: day.active ? "#3F68B1" : "#FFFFFF",*/}
                {/*                                color: day.active ? "#FFFFFF" : "#3F68B1",*/}
                {/*                                border: "1px solid #3F68B1"*/}
                {/*                            }}*/}
                {/*                        >*/}
                {/*                            { day.text }*/}
                {/*                         </span>*/}
                {/*                        <TimePicker*/}
                {/*                            label = { day.time ? day.time : "Choose Time" }*/}
                {/*                            className = "editUserTimePickerInput"*/}
                {/*                            value = { day.time ? new Date(day.time) : null }*/}
                {/*                            onChange = { value => changeTime.apply(this, [value, day]) }*/}
                {/*                        />*/}
                {/*                        <div className="editUserSocialMediaCheckinBox">*/}
                {/*                            <span className="addUserCustomClientCheckSpan">*/}
                {/*                                <label className="checkboxLabel">*/}
                {/*                                      <input*/}
                {/*                                          type = 'checkbox'*/}
                {/*                                          checked = { day.postToFacebook }*/}
                {/*                                          onClick = { changeFacebook.bind(this,day) }*/}
                {/*                                      />*/}
                {/*                                      <span></span>*/}
                {/*                                </label>*/}
                {/*                                Facebook*/}
                {/*                            </span>*/}
                {/*                            <span className="addUserCustomClientCheckSpan">*/}
                {/*                                <label className="checkboxLabel">*/}
                {/*                                    <input*/}
                {/*                                        type='checkbox'*/}
                {/*                                        checked={ day.postToInstagram }*/}
                {/*                                        onChange={ changeInstagram.bind(this, day) }*/}
                {/*                                    />*/}
                {/*                                    <span></span>*/}
                {/*                                </label>*/}
                {/*                                Instagram*/}
                {/*                            </span>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                )*/}
                {/*            }*/}
                {/*        </div>*/}
                {/*        <span*/}
                {/*            className="addUserCustomClientCheckSpan"*/}
                {/*            style = {{ marginTop: "30px" }}*/}
                {/*        >*/}
                {/*            <label*/}
                {/*                className="checkboxLabel"*/}
                {/*            >*/}
                {/*                  <input*/}
                {/*                      type = 'checkbox'*/}
                {/*                      checked = { holidaysPosts }*/}
                {/*                      onChange = { e => setHolidaysPosts(e.target.checked) }*/}
                {/*                  />*/}
                {/*                  <span></span>*/}
                {/*            </label>*/}
                {/*            Holiday Posts*/}
                {/*        </span>*/}
                {/*        <div className="addUserHolidaysBox">*/}
                {/*            {*/}
                {/*                holidays.map(hol =>*/}
                {/*                    <span className="addUserConcretHolidayCheckBox" key = { hol.id } >*/}
                {/*                        <label*/}
                {/*                            className = "checkboxLabel"*/}
                {/*                            style = {{ color: showHolidays ? "#7779A7" : "rgba(0,0,0,0.1)" }}*/}
                {/*                        >*/}
                {/*                            <input*/}
                {/*                                type = 'checkbox'*/}
                {/*                                checked = { hol.active }*/}
                {/*                                onChange = { checkedThisHoliday.bind(this, hol) }*/}
                {/*                            />*/}
                {/*                            <span></span>*/}
                {/*                            { hol.name }*/}
                {/*                        </label>*/}
                {/*                    </span>*/}
                {/*                )*/}
                {/*            }*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    <div className="addUserSubmitBox">*/}
                {/*        <input*/}
                {/*            type="submit"*/}
                {/*            value="UPDATE"*/}
                {/*            className="addUserSubmitBtn"*/}
                {/*            style={{*/}
                {/*                backgroundColor: typeProfile || typeCategory || facebookId ? "#3F68B1" : "white",*/}
                {/*                color: typeProfile || typeCategory || facebookId ? "#FAFAFA" : "#929292"*/}
                {/*            }}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}
                    <input
                        type="submit"
                        value="UPDATE"
                        className="addUserSubmitBtn"
                        style={{
                            backgroundColor: typeProfile || typeCategory || facebookId ? "#3F68B1" : "white",
                            color: typeProfile || typeCategory || facebookId ? "#FAFAFA" : "#929292"
                        }}
                    />
            </form>
        </div>
    )
}


export default EditUser
